import { Grid } from '@mui/material'
import {
//   SelectInput,
  SimpleForm,
  TextInput,
  required,
  BooleanInput,
//   useTranslate,
//   ReferenceInput,
//   useLocaleState,
  useEditContext,
  Loading,
//   ReferenceField,
//   TextField,
//   SimpleShowLayout,
} from 'react-admin'
import { COMMON_FIELDS, CATALOGUES_FIELDS } from '../../providers/localization/constant'
import { EditBase } from '../../components/base'
import { FormBottomToolbarWithPermission } from '../../components/form'
import { SigleFileInput } from '../../components/inputs/SigleFileInput'

const EditForm = (): JSX.Element => {
  const { record, isLoading } = useEditContext()
  if (isLoading) return <Loading />
  const isApproved: boolean = record?.is_approved
  const isPublished: boolean = record?.is_published
  const preventEdit = isApproved || isPublished

  return (
    <SimpleForm  toolbar={
        <FormBottomToolbarWithPermission encType='multipart/form-data' hasConfirm={true} />
      }>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <TextInput
            source='title_th'
            label={`${CATALOGUES_FIELDS}.title_th`}
            fullWidth
            validate={[required()]}
            disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            source='title_en'
            label={`${CATALOGUES_FIELDS}.title_en`}
            fullWidth
            validate={[required()]}
            disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            source='description_th'
            label={`${CATALOGUES_FIELDS}.description_th`}
            fullWidth
            multiline
            maxRows={4}
            validate={[required()]}
            disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            source='description_en'
            label={`${CATALOGUES_FIELDS}.description_en`}
            fullWidth
            multiline
            maxRows={4}
            validate={[required()]}
            disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            source='period_th'
            label={`${CATALOGUES_FIELDS}.period_th`}
            fullWidth
            validate={[required()]}
            disabled={preventEdit}
          />
        </Grid>
        <Grid item xs={6}>
          <TextInput
            source='period_en'
            label={`${CATALOGUES_FIELDS}.period_en`}
            fullWidth
            validate={[required()]}
            disabled={preventEdit}
          />
        </Grid>
        <Grid item>
            <BooleanInput
              color='primary'
              source='is_active'
              label={`${COMMON_FIELDS}.status.label`}
            />
          </Grid>

        <Grid item xs={12}>
          <SigleFileInput
            source='file'
            isApproved={preventEdit}
            label={`${CATALOGUES_FIELDS}.edit.file`}
            helperText={`${CATALOGUES_FIELDS}.edit.attachment_helper`}
            fallbackSource='full_path'
            accept='application/pdf'
          />
        </Grid>
      </Grid>
    </SimpleForm>
  )
}

const FileEdit = (): JSX.Element => {
  return (
    <EditBase
      title={`${CATALOGUES_FIELDS}.edit.title`}
      encType='multipart/form-data'
      actions={false}
      listAction={{
        hasShow: false,
        hasBackButton: true,
      }}
    >
      <EditForm />
    </EditBase>
  )
}

export default FileEdit
